export const TEST_IDS = {
  RESCHEDULE_BTN: 'reschedule-btn',
};
